import React, { useEffect, useRef } from "react";

const formatCurrency = (value) =>
  Math.round(Number(value) || 0).toLocaleString("en-US");

export default function SharedBarcodePicker({
  barcode,
  options,
  onSelect,
  onCancel,
  title = "Choose the scanned product",
  description,
  showAvailability = true,
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef.current
      ?.querySelector(".shared-barcode-option, .shared-barcode-cancel")
      ?.focus();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      onCancel();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = Array.from(
      dialogRef.current?.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ) || [],
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };

  return (
    <div className="modal-overlay" data-shared-barcode-picker>
      <div
        ref={dialogRef}
        className="modal shared-barcode-picker"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shared-barcode-picker-title"
        onKeyDown={handleKeyDown}
      >
        <div className="modal-header">
          <div>
            <h2 id="shared-barcode-picker-title">{title}</h2>
            <p>{description || `Barcode ${barcode} matches more than one packaging unit.`}</p>
          </div>
        </div>
        <div className="shared-barcode-options">
          {options.map((option) => (
            <button
              type="button"
              className="shared-barcode-option"
              key={`unit-${option.unitId}`}
              onClick={() => onSelect(option)}
            >
              <span className="shared-barcode-option-name">{option.name}</span>
              <span className="shared-barcode-option-unit">{option.unitName}</span>
              <span>1 unit = {option.conversionFactor} base unit{Number(option.conversionFactor) === 1 ? "" : "s"}</span>
              <span>MMK {formatCurrency(option.price)}</span>
              {showAvailability && <span>{option.availableUnits} available</span>}
            </button>
          ))}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary shared-barcode-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
